import DialogForm from '@/js/components/DialogForm'

export default class DialogRegister extends DialogForm {
    name = 'register'

    onSubmitSuccess() {
        location.reload()
    }

    beforeShow() {
        location.hash = this.name
    }

    afterShow() {
        this.refs.form.querySelector('input[name="name"]').focus()

        const recaptcha = this.refs.form.querySelector('.g-recaptcha')

        if (recaptcha && !recaptcha.children.length && window.grecaptcha) {
            window.grecaptcha.render(recaptcha)
        }
    }

    afterHide() {
        const hash = location.hash.substring(1)

        if (hash === this.name) {
            history.replaceState(null, null, ' ')
        }
    }
}
